import React from "react";
import { teamColors } from "../constants/index";

const TeamLogo = ({ teamId = "", isFirstTeam = false }) => {
  const teamColor = teamColors[teamId];
  const isRealLogo = teamColor.length === 0;

  return isRealLogo ? (
    <img
      src={`/flags/${teamId}.png`}
      alt=""
      className="h-8 w-8 rounded-full object-contain "
      style={{
        marginRight: isFirstTeam ? 8 : 0,
        marginLeft: !isFirstTeam ? 8 : 0,
      }}
    />
  ) : (
    <div className="flex flex-col">
      <div
        className="w-2.5 h-3"
        style={{ backgroundColor: teamColor[0] }}
      ></div>
      <div
        className="w-2.5 h-3"
        style={{ backgroundColor: teamColor[1] }}
      ></div>
    </div>
  );
};

export default TeamLogo;
